import MainLayout from '../layouts/MainLayout';
import { SubRoutes } from './SubRoutes';

export const MainRoutes = (signOut: () => void): any[] => [
  {
    path: '/',
    label: 'Home',
    element: <MainLayout signOut={signOut} />,
    nestedRoutes: SubRoutes(),
  },
];
